import { getToken, removeToken } from '@/utils/auth';
import { API_URL } from '@/config';

let once = false;

export const Api: any = new Proxy(
  {},
  {
    get(_, modKey: string) {
      return new Proxy(
        {},
        {
          get(__, fnKey: string) {
            const url = API_URL + `/${modKey}/${fnKey}`;
            return (params: any) => {
              let query = '';
              params = params || {};
              if (typeof params !== 'object') {
                throw new Error('api argument must be object');
              }
              if (params) {
                params.token = getToken();
                query = '?q=' + JSON.stringify(params).replace(/&/g, '%26');
              }
              return new Promise((resolve, reject) =>
                fetch(url + query)
                  .then((r) => r.json())
                  .then(async (res) => {
                    if (res.error === 'jwt expired' && once === false) {
                      console.error('[TOKEN INVALID]:', res.error);
                      once = true;
                      removeToken();
                      if (res.error) {
                        reject(res.error);
                      }
                      resolve(res);
                      //TODO: if token invalid to do something.
                    }
                    if (res.error) {
                      console.error('[API WARNING]:', res.error);
                      reject(res.error);
                    }
                    once = false;
                    resolve(res);
                  }),
              );
            };
          },
        },
      );
    },
  },
);
